import { Component, ChangeDetectionStrategy } from '@angular/core';

import { TranslocoModule } from '@jsverse/transloco';
import { PipesModule } from '@cbcore/pipes/pipes.module';
import { UnitsDistributionBase } from '../base/units-distribution.base';

@Component({
    selector: 'ud-ice-hockey',
    templateUrl: './default/ice-hockey/ice-hockey.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TranslocoModule, PipesModule]
})
export class IceHockeyComponent extends UnitsDistributionBase {
  // Used for ICE_HOCKEY_CORRECT_SCORE
  override getUnits(distribution: any): number {
    return super.getUnits(distribution);
  }
}